export default {
  TO_COMPLETE: '0',
  VERIFYING: '1',
  EXPIRED: '2',
  ACCEPTED: '3',
  REFUSED: '4'
}
